export const PORTAL_ADMIN_ROLE_CODES = ["slt", "dev"] as const;

export function canAccessPortalAdministration(
	roles: string[],
	permissions: string[] = [],
) {
	return (
		permissions.some((permission) =>
			["timetables.manage", "map.manage"].includes(permission.toLowerCase()),
		) ||
		roles.some((role) =>
			PORTAL_ADMIN_ROLE_CODES.includes(
				role as (typeof PORTAL_ADMIN_ROLE_CODES)[number],
			),
		)
	);
}
